/*
 * NCW sale countdown — "NCW Sale Ends In [XX days] XX hours XX minutes XX seconds".
 * Markup comes from snippets/ncw-countdown.liquid. Timers render hidden and are shown
 * here once a valid, future end date is found; when the sale ends they hide themselves.
 */
(function () {
  var timer = null;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function start() {
    if (timer) clearInterval(timer);

    var items = Array.prototype.map.call(document.querySelectorAll('[data-ncw-countdown]'), function (el) {
      return {
        el: el,
        end: Date.parse(el.getAttribute('data-end')),
        showDays: el.getAttribute('data-show-days') !== 'false'
      };
    });
    if (!items.length) return;

    function tick() {
      var now = Date.now();
      var running = 0;

      items.forEach(function (item) {
        var diff = item.end - now;
        if (isNaN(diff) || diff <= 0) {
          item.el.hidden = true;
          return;
        }
        running++;
        var s = Math.floor(diff / 1000);
        var values = {
          d: Math.floor(s / 86400),
          // without the days unit, hours carry the full remaining time
          h: item.showDays ? Math.floor((s % 86400) / 3600) : Math.floor(s / 3600),
          m: Math.floor((s % 3600) / 60),
          s: s % 60
        };
        item.el.querySelectorAll('[data-cd]').forEach(function (node) {
          node.textContent = pad(values[node.getAttribute('data-cd')]);
        });
        item.el.hidden = false;
      });

      if (!running && timer) {
        clearInterval(timer);
        timer = null;
      }
      return running;
    }

    if (tick()) timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // theme editor: re-scan when sections are added or changed
  document.addEventListener('shopify:section:load', start);
})();
